import React from "react";
import { Icon } from "../../icons/icons";

const Destination = ({ children, className }) => {
  return (
    <div className={className || "flex"}>
      <div className="iconsImgFilter">
        <Icon name={"villaLocation"}></Icon>
      </div>
      <span className="font-bold text-13 lg:text-sm opacity-50 ml-2">
        {children}
      </span>
    </div>
  );
};

export default Destination;
